export default value => Boolean(value.match(/ä|ö|ü/i));
